import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FormControl, FormGroup, FormBuilder, Validators } from '@angular/forms';

import { Observable, Subject } from 'rxjs';

import { LoadingPage } from '../../../shared/components/loading/loading.page.component';
import { ProfileService } from './profile.service';
import { NotificationService } from '../../../core/services/notification.service';
import { FlexibleDropdownConfig } from '../../../shared/components/flexible-dropdown/flexible-dropdown.component';
import {ModalSize, SmartModalService} from '../../services/smart-modal.service';
import {SimpleAlertComponent} from '../../../shared/components/modal/simple-alert.component';
import {SimpleInfoComponent} from '../../../shared/components/modal/simple-info.component';
import {ItpxValidators} from '../../../shared/validators/itpx-validators';

@Component({
    selector: 'itpx-profile',
    templateUrl: './profile.component.html',
    styleUrls: ['./profile.component.css']
})
export class ProfileComponent extends LoadingPage {

    private profile: FormGroup;
    private saving: boolean;
    private deleting: boolean;
    private languageConfig: FlexibleDropdownConfig;
    private timezoneConfig: FlexibleDropdownConfig;

    private formSubmit = new Subject<Account>();
    private requestDataDeletion = new Subject<any>();
    private profileAccount: any;
    public showPrivacyPolicy:boolean = false;
    private onClickPrivacyPolicy = new Subject<any>();
    public privacyPolicy: string;

    constructor(
        private fb: FormBuilder,
        private profileService: ProfileService,
        private notificationService: NotificationService,
        private modalService: SmartModalService,
        private router: Router
    ) {
        super();
    }

    ngOnInit() {

        // this.timezoneConfig = new FlexibleDropdownConfig();
        // this.timezoneConfig.label = 'Timezone';
        // this.timezoneConfig.placeholder = 'Select timezone...';
        // this.timezoneConfig.forceRefresh = Observable.never();
        // this.timezoneConfig.dictionaryFactory = () => this.addressService.listAddressesDictionary().map(body => body.data);

        this.profile = this.fb.group({
            email: [null, []],
            firstName: [null, [Validators.required, Validators.minLength(1), ItpxValidators.nonAsciiCharacter]],
            lastName: [null, [Validators.required, Validators.minLength(1), ItpxValidators.nonAsciiCharacter]],
            timeZone: [null, [Validators.required]],
            language: [null, [Validators.required]]
        });

        this.profileService.getProfile()
            .do(_ => this.loading())
            .map(body => body.data)
            .bindToLifecycle(this)
            .subscribe(data => {
                this.profileAccount = data;
                this.profile.setValue({
                    email: data.username,
                    firstName: data.firstName,
                    lastName: data.lastName,
                    timeZone: data.timeZone,
                    language: data.language
                }, {emitEvent: false});

                let language = data.language ? ({ key: data.language }) : null;
                let timezone = data.timeZone ? ({ key: data.timeZone }) : null;

                this.initDropdowns(language, timezone);
                this.ready();
            }, err => this.error());

        this.formSubmit
            .do(_ => this.startLoading())
            .flatMap(acc => this.profileService.editProfile(acc)
                .finally(() => this.endLoading())
                .neverError()
            )
            .bindToLifecycle(this)
            .subscribe(_ => {
                this.profile.markAsPristine();
                this.notificationService.success('Successfully updated your profile', 'Success');
            });

        this.requestDataDeletion
          .do(_ => {
            window.scrollTo(0,0);
            this.showPrivacyPolicy = false;
            this.loading()
          })
          .flatMap(account => this.profileService.requestDataDeletion(account)
            .finally(() => this.ready())
            .neverError())
          .bindToLifecycle(this)
          .subscribe(_ => {
            this.modalService.open(SimpleAlertComponent, {text: 'brandedPortal.GDPR.dataremovaltriggerred', html: true}, 'Request Data Deletion', ModalSize.Md)
              .neverError()
              .subscribe();
          });

        this.onClickPrivacyPolicy
          .do(_ => this.loading())
          .flatMap(policy => this.profileService.loadPrivacyPolicy()
            .finally(() => this.ready())
          )
          .subscribe(policy => {
            this.privacyPolicy = policy.data.content;
            this.showPrivacyPolicy = true;
          });
    }

    private errorHandler(error: any): void {
      if(error)
        this.notificationService.error(error);
    }

    private initDropdowns(selectedLanguage: any, selectedTimezone: any) {
        this.languageConfig = new FlexibleDropdownConfig();
        this.languageConfig.label = 'Language';
        this.languageConfig.initialItem = selectedLanguage;
        this.languageConfig.hideForm = true;
        this.languageConfig.placeholder = 'Select language...';
        this.languageConfig.forceRefresh = Observable.never();
        this.languageConfig.questions = [];
        this.languageConfig.dictionaryFactory = () => this.profileService.getLanguagesDictionary().map(body => body.data);

        this.timezoneConfig = new FlexibleDropdownConfig();
        this.timezoneConfig.label = 'Timezone';
        this.timezoneConfig.initialItem = selectedTimezone;
        this.timezoneConfig.hideForm = true;
        this.timezoneConfig.placeholder = 'Select timezone...';
        this.timezoneConfig.forceRefresh = Observable.never();
        this.timezoneConfig.questions = [];
        this.timezoneConfig.dictionaryFactory = () => this.profileService.getTimezonesDictionary().map(body => body.data);
    }

    private startLoading() {
        this.profile.disable();
        this.saving = true;
    }

    private endLoading() {
        this.profile.enable();
        this.saving = false;
    }

    private startLoadingDelete() {
      this.profile.disable();
      this.saving = false;
      this.deleting = true;
    }

    private endLoadingDelete() {
      this.profile.enable();
      this.deleting = false;
    }

    private save({ value, valid }: { value: any, valid: boolean }) {
        this.formSubmit.next(value);
    }

    private onRequestDataDeletion(){
      this.modalService.open(SimpleInfoComponent, {text: 'brandedPortal.GDPR.dataremovalconfirmation', 
      html: true, btnNoText: 'No', btn: 'btn-default', btnNoClass: 'btn-primary'}, 'Request Data Deletion', ModalSize.Md)
        .neverError()
        .subscribe(r => {
          if(r)
            this.requestDataDeletion.next(this.profileAccount);
        });
    }

    private openPrivacyPolicy(){
      this.onClickPrivacyPolicy.next(true);
    }
}



// WEBPACK FOOTER //
// ./src/app/core/components/profile/profile.component.ts